
import React, { useEffect, useState } from "react";
import { FileText, ArrowLeft, ArrowUpRight } from "lucide-react";
import {
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import API_BASE_URL from "../api/api"

// const API_URL =
//   window.location.hostname === "localhost" ||
//   window.location.hostname === "127.0.0.1"
//     ? "http://127.0.0.1:8000/api/home-documents"
//     : "https://api.kunainital.ac.in/api/home-documents";
const API_URL = `${API_BASE_URL}/home-documents?limit=all`;

export default function NoticesPage() {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const [documents, setDocuments] = useState([]);
  const [active, setActive] = useState(
    searchParams.get("tab") || ""
  );
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDocuments = async () => {
      try {
        const response = await fetch(API_URL);

        if (!response.ok) {
          throw new Error(`HTTP Error: ${response.status}`);
        }

        const result = await response.json();

        console.log("Total documents from API:", result.data?.length);
        console.log("API response:", result.data);

        if (result.status === true && Array.isArray(result.data)) {
          const activeDocuments = result.data.filter(
            (item) => Number(item.status) === 1
          );

          setDocuments(activeDocuments);

          const tabs = [
            ...new Set(
              activeDocuments
                .map((item) => item.event_type)
                .filter(Boolean)
            ),
          ];

          const requestedTab = searchParams.get("tab");

          setActive(
            requestedTab && tabs.includes(requestedTab)
              ? requestedTab
              : tabs[0] || ""
          );
        } else {
          setDocuments([]);
        }
      } catch (error) {
        console.error("Error fetching documents:", error);
        setDocuments([]);
      } finally {
        setLoading(false);
      }
    };

    fetchDocuments();
  }, []);

  const dynamicTabs = [
    ...new Set(
      documents.map((item) => item.event_type).filter(Boolean)
    ),
  ];

  const currentDocuments = documents.filter(
    (item) => item.event_type === active
  );

  const formatEventType = (value) => {
    if (!value) return "";

    return value
      .replace(/[-_]/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const handleTabChange = (eventType) => {
    setActive(eventType);
    setSearchParams({ tab: eventType });
  };

  return (
    <section className="min-h-screen bg-gradient-to-b from-[var(--paper)] to-[var(--cream)] py-16">
      <div className="max-w-7xl mx-auto px-6">

       <button
  type="button"
  onClick={() => navigate("/")}
  className="inline-flex items-center gap-2 mb-8 px-4 py-2 rounded-md bg-red-600 text-white font-semibold hover:bg-red-700 transition-colors"
>
  <ArrowLeft size={18} />
  Back
</button>
        <div className="text-center">
          <h1 className="font-display text-3xl md:text-5xl font-bold text-red-700">
            Notice Board
          </h1>

          <p className="mt-3 text-gray-600">
            All notices, announcements and documents
          </p>
        </div>

        {!loading && dynamicTabs.length > 0 && (
          <div className="mt-8 flex flex-wrap justify-center gap-2">
            {dynamicTabs.map((eventType) => (
              <button
                key={eventType}
                type="button"
                onClick={() => handleTabChange(eventType)}
                className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-semibold border transition-all ${
                  active === eventType
                    ? "bg-[var(--terracotta)] text-white border-[var(--terracotta)] shadow-lg"
                    : "bg-white text-[var(--ink)] border-[var(--cream-deep)] hover:border-[var(--terracotta)]"
                }`}
              >
                <FileText size={15} />
                {formatEventType(eventType)}
              </button>
            ))}
          </div>
        )}

        <div className="mt-10 mb-5">
          <h2 className="text-xl md:text-2xl font-bold text-[var(--ink)]">
            {formatEventType(active)}
          </h2>

          {!loading && (
            <p className="mt-1 text-sm text-gray-500">
              Total documents: {currentDocuments.length}
            </p>
          )}
        </div>

        {loading && (
          <div className="text-center py-12 text-gray-500">
            Loading notices...
          </div>
        )}

        {!loading && currentDocuments.length === 0 && (
          <div className="text-center py-12 text-gray-500">
            No documents available in this category.
          </div>
        )}

        <div className="grid md:grid-cols-2 gap-4">
          {!loading &&
            currentDocuments.map((item) => (
              <a
                key={item.id}
                href={item.pdf_path || item.external_link || "#"}
                target="_blank"
                rel="noopener noreferrer"
                onClick={(e) => {
                  if (!item.pdf_path && !item.external_link) {
                    e.preventDefault();
                  }
                }}
                className="group flex items-start gap-4 rounded-2xl bg-white p-5 border border-[var(--cream-deep)] hover:shadow-lg transition-all"
              >
                <div className="shrink-0 w-12 h-12 rounded-xl bg-[var(--terracotta)]/10 flex items-center justify-center">
                  <FileText
                    size={24}
                    className="text-[var(--terracotta)]"
                  />
                </div>

                <div className="flex-1 min-w-0">
                  <h3 className="text-sm md:text-base leading-snug text-[var(--ink)] group-hover:text-[var(--terracotta)]">
                    {item.heading}
                  </h3>

                  <div className="mt-2 flex flex-wrap items-center gap-2 text-xs text-gray-500">
                    {item.publish_date && (
                      <span>{item.publish_date}</span>
                    )}

                    <span className="text-[var(--terracotta)] font-semibold">
                      {formatEventType(item.event_type)}
                    </span>
                  </div>
                </div>

                <ArrowUpRight
                  size={18}
                  className="shrink-0 text-[var(--terracotta)]"
                />
              </a>
            ))}
        </div>
      </div>
    </section>
  );
}
